import React, {useEffect, useState} from "react";
import useQuery from "../../../hook/useQuery";
import useToastNotify from "../../../hook/useToastNotify";
import {IPurchaseDetailsData} from "../../../contracts/data/purchase";
import {IRouterListToData} from "../../../contracts/data/router";
import {Link, useLocation} from "react-router-dom";
import httpClient from "../../../services/httpClient";
import {purchasesApi} from "../../../constans/apiUrls";
import PageHeader from "../../Elements/PageHeader";
import Loading from "../../Elements/Loading/Loading";
import {RouterStateSectionType} from "../../../constans/enumTypes";
import DetailsCard from "../../Elements/DetailsCard";
import {
    generateMethodPaymentTitle,
    generatePaidStatusTitle,
    isNotEmpty,
    priceFormatWithUnitToman
} from "../../../helpers/functions";
import TableTr from "../../Elements/Table/TableTr";
import TableTd from "../../Elements/Table/TableTd";
import TableTdContent from "../../Elements/Table/TableTdContent";
import TableEmpty from "../../Elements/Table/TableEmpty";
import Table from "../../Elements/Table";

const ViewDetailsPurchase: React.FC = () => {
    const queryParams = useQuery()
    const {toastNotify} = useToastNotify()
    const [detailsData, setDetailsData] = React.useState<IPurchaseDetailsData | null>()
    const [loading, setLoading] = useState<boolean>(true)
    const location = useLocation<IRouterListToData>()

    const titleVideoProductHeadTable: Array<string> = ['#', 'عنوان', 'درصد تخفیف', 'قیمت اصلی', 'قیمت نهایی']

    const fetchDetailsPurchaseData = async () => {
        await httpClient().get(`${purchasesApi.details}/${queryParams.get('id')}`)
            .then(response => {
                if(response.status === 200){
                    setDetailsData(response?.data?.data)
                }
            })
            .catch(error => {
                setDetailsData(null)
                toastNotify('error', 'مشکل در دریافت اطلاعات از سرور')
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        fetchDetailsPurchaseData()
    }, [])

    const itemsTableRows = detailsData?.videos_products?.map((item, index) =>
        <TableTr key={`table-row${index}`}>
            <TableTd><TableTdContent content={`${index + 1}`}/></TableTd>
            <TableTd><TableTdContent content={item?.info?.title} hasImage={true} image={item?.info?.cover_image_url} /></TableTd>
            <TableTd><TableTdContent content={item?.percent > 0 ? `${item?.percent}%` : "-"}/></TableTd>
            <TableTd><TableTdContent content={priceFormatWithUnitToman(item?.price)}/></TableTd>
            <TableTd><TableTdContent content={priceFormatWithUnitToman(item?.real_price)}/></TableTd>
        </TableTr>
    )
    

    return(
        <React.Fragment>
            <PageHeader title={`مشاهده سفارش ${detailsData?.code}`} isBackBtn urlBackBtn={`${location?.state?.page}?page_num=${location?.state?.page_num}${location?.state?.section === RouterStateSectionType.USER ? "&id=" + location?.state?.userId : ""}&name=${queryParams.get('name')}`}/>
            {loading ? <Loading /> :
                <div>
                    {detailsData &&
                        <React.Fragment>
                            <div className={"border rounded-xl bg-blue-50 p-4 mb-6"}>
                                <div className={"flex flex-row justify-between items-center pb-4 mb-4 border-b border-gray-300 border-dashed"}>
                                    <h4 className={"text-gray-400 text-xl font-bold"}>اطلاعات سفارش دهنده</h4>
                                    {/*<Link to={{*/}
                                    {/*    pathname: '/dashboard/users/profile',*/}
                                    {/*    search: `?id=${detailsData?.user_info?.id}&name=${detailsData?.user_info?.first_name + " " + detailsData?.user_info?.last_name}`,*/}
                                    {/*    state: {section: RouterStateSectionType.PURCHASE_VIEW, page: location.pathname, page_num: 1, purchaseId:queryParams.get('id')}*/}
                                    {/*}}><div className={"text-sm text-blue-600 cursor-pointer underline hover:opacity-70"}>پروفایل کاربر</div></Link>*/}
                                </div>
                                <div className={"grid grid-cols-1 md:grid-cols-2 gap-4"}>
                                    <DetailsCard title={"نام و نام خانوادگی"} content={detailsData?.user_info?.first_name + " " + detailsData?.user_info?.last_name} />
                                    <DetailsCard title={"شماره موبایل"} content={detailsData?.user_info?.mobile} />
                                    <DetailsCard title={"ایمیل"} content={isNotEmpty(detailsData?.user_info?.email) ? detailsData?.user_info?.email! : "-"} />
                                </div>
                            </div>
                            <div className={"border rounded-xl bg-blue-50 p-4 mb-6"}>
                                <h4 className={"text-gray-400 text-xl font-bold pb-4 mb-4 border-b border-gray-300 border-dashed"}>اطلاعات پرداخت</h4>
                                <div className={"grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"}>
                                    <DetailsCard title={"مبلغ پرداختی"} content={priceFormatWithUnitToman(detailsData?.payment_info?.amount)} />
                                    <DetailsCard title={"نوع پرداخت"} content={generateMethodPaymentTitle(detailsData?.payment_info?.method)!} />
                                    <DetailsCard title={"عنوان درگاه"} content={isNotEmpty(detailsData?.payment_info?.gateway_name) ? detailsData?.payment_info?.gateway_name : "-"} />
                                    <DetailsCard title={"کد ارجاع"} content={detailsData?.payment_info?.ref_num} />
                                    <DetailsCard title={"وضعیت پرداخت"} content={generatePaidStatusTitle(detailsData?.paid_status)!} />
                                </div>
                            </div>
                            <div className={"border rounded-xl bg-blue-50 p-4 mb-6"}>
                                <h4 className={"text-gray-400 text-xl font-bold pb-4 mb-4 border-b border-gray-300 border-dashed"}>اطلاعات سفارش</h4>
                                <div className={"grid grid-cols-1 md:grid-cols-2 gap-4"}>
                                    <DetailsCard title={"کد سفارش"} content={detailsData?.code} />
                                    <DetailsCard title={"تعداد محصول در سفارش"} content={`${detailsData?.videos_products.length}`} />
                                    <DetailsCard title={"تاریخ سفارش"} content={detailsData?.created_time_jalali.split(",")[1]} />
                                    <DetailsCard title={"ساعت سفارش"} content={detailsData?.created_time_jalali.split(",")[0]} />
                                    <DetailsCard title={"قیمت کل خرید"} content={priceFormatWithUnitToman(detailsData?.total_price!)} />
                                    <DetailsCard title={"قیمت نهایی خرید"} content={detailsData?.final_price <= 0 && detailsData?.is_free ? "رایگان" : priceFormatWithUnitToman(detailsData?.final_price!)} />
                                    <DetailsCard title={"قیمت تخفیف داده شده"} content={detailsData?.discount > 0 ? priceFormatWithUnitToman(detailsData?.discount) : "-"} />
                                    <DetailsCard title={"کد تخفیف"} content={isNotEmpty(detailsData?.coupon_code) ? detailsData?.coupon_code! : "-"} />
                                    <DetailsCard title={"مقدار کد تخفیف"} content={isNotEmpty(detailsData?.coupon_value) ?` ${detailsData?.coupon_value}` : "-"} />
                                    <DetailsCard title={"قیمت تخفیف"} content={detailsData?.discount_coupon > 0 ? `${detailsData?.discount_coupon}` : "-"} />
                                </div>
                            </div>
                            <div className={"border rounded-xl bg-blue-50 p-4 mb-6"}>
                                <h4 className={"text-gray-400 text-xl font-bold pb-4 mb-4 border-b border-gray-300 border-dashed"}>لیست جزییات سفارشات</h4>
                                <div className={""}>
                                    <Table isLoading={loading} titlesTable={titleVideoProductHeadTable} isSearch={false}>
                                        {itemsTableRows!.length > 0 ? itemsTableRows :
                                            <TableEmpty colSpan={titleVideoProductHeadTable.length} message={"محصولی یافت نشد"}/>}
                                    </Table>
                                </div>
                            </div>
                        </React.Fragment>
                    }
                </div>
            }
        </React.Fragment>
    )
}

export default ViewDetailsPurchase